@if (stats) {
<div class="stats-wrapper">
	<div class="stats-header">
		<mat-icon class="stats-header-icon">query_stats</mat-icon>
		<span class="stats-header-label">{{ 'CLIPS.STATS.DAILY_STATS' | translate }}</span>
	</div>

	<div class="stats-row">
		<!-- Card 1: Brand mentions (brand) / Total thematic clips (non-brand) -->
		@if (stats.totalClips) {
		<div class="stat-card">
			<span class="stat-label">
				{{ (hasCompanyTags ? 'CLIPS.STATS.BRAND_MENTIONS' : 'CLIPS.STATS.TOTAL_THEMATIC_CLIPS') | translate }}
				<mat-icon class="stat-info-icon" matTooltipClass="wide-tooltip" matTooltipPosition="above"
					[matTooltip]="(hasCompanyTags ? 'CLIPS.STATS.BRAND_MENTIONS_INFO' : 'CLIPS.STATS.TOTAL_THEMATIC_CLIPS_INFO') | translate">info_outline</mat-icon>
			</span>
			<div class="stat-row">
				<span class="stat-value">{{ stats.totalClips.today ?? 0 }}</span>
				@if (totalClipsDelta() !== 0) {
				<span class="stat-delta" [class.up]="totalClipsDelta() > 0" [class.down]="totalClipsDelta() < 0">
					<mat-icon>{{ totalClipsDelta() > 0 ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					{{ totalClipsDelta() > 0 ? '+' : '' }}{{ totalClipsDelta() }} {{ 'CLIPS.STATS.LAST_24_HOURS' | translate }}
				</span>
				}
			</div>
		</div>
		}

		@if (hasCompanyTags) {
		<!-- Card 2: Total influence -->
		@if (stats.totalSentimentScore) {
		<div class="stat-card">
			<span class="stat-label">
				{{ 'CLIPS.STATS.TOTAL_INFLUENCE' | translate }}
				<mat-icon class="stat-info-icon" matTooltipClass="wide-tooltip" matTooltipPosition="above"
					[matTooltip]="'CLIPS.STATS.TOTAL_INFLUENCE_INFO' | translate">info_outline</mat-icon>
			</span>
			<div class="stat-row">
				<span class="stat-value" [class.positive]="(stats.totalSentimentScore.today ?? 0) > 0" [class.neutral]="stats.totalSentimentScore.today === 0" [class.negative]="(stats.totalSentimentScore.today ?? 0) < 0">
					{{ (stats.totalSentimentScore.today ?? 0) > 0 ? '+' : '' }}{{ stats.totalSentimentScore.today ?? 0 }}
				</span>
				@if (sentimentScoreDelta() !== 0) {
				<span class="stat-delta" [class.up]="sentimentScoreDelta() > 0" [class.down]="sentimentScoreDelta() < 0">
					{{ sentimentScoreDelta() > 0 ? '+' : '' }}{{ sentimentScoreDelta() }} {{ 'CLIPS.STATS.LAST_24_HOURS' | translate }}
				</span>
				}
			</div>
		</div>
		}

		<!-- Card 3: Sentiment analysis (scores line) -->
		@if (stats.sentiments?.today) {
		<div class="stat-card">
			<span class="stat-label">
				{{ 'CLIPS.STATS.SENTIMENT_ANALYSIS' | translate }}
				<mat-icon class="stat-info-icon" matTooltipClass="wide-tooltip" matTooltipPosition="above"
					[matTooltip]="'CLIPS.STATS.SENTIMENT_ANALYSIS_INFO' | translate">info_outline</mat-icon>
			</span>
			<div class="sentiment-bar">
				<span class="sentiment-segment positive" [style.width.%]="sentimentPercent('positive')" [matTooltip]="'CLIPS.STATS.POSITIVE' | translate"></span>
				<span class="sentiment-segment neutral" [style.width.%]="sentimentPercent('neutral')" [matTooltip]="'CLIPS.STATS.NEUTRAL' | translate"></span>
				<span class="sentiment-segment negative" [style.width.%]="sentimentPercent('negative')" [matTooltip]="'CLIPS.STATS.NEGATIVE' | translate"></span>
			</div>
			<div class="sentiment-counts">
				<span class="sentiment-count positive" [matTooltip]="'CLIPS.STATS.POSITIVE' | translate">
					<span class="dot"></span>{{ stats.sentiments?.today?.positive ?? 0 }}
				</span>
				<span class="sentiment-count neutral" [matTooltip]="'CLIPS.STATS.NEUTRAL' | translate">
					<span class="dot"></span>{{ stats.sentiments?.today?.neutral ?? 0 }}
				</span>
				<span class="sentiment-count negative" [matTooltip]="'CLIPS.STATS.NEGATIVE' | translate">
					<span class="dot"></span>{{ stats.sentiments?.today?.negative ?? 0 }}
				</span>
			</div>
		</div>
		}

		<!-- Card 4: Avg visibility -->
		@if (stats.averageVisibilityIndex) {
		<div class="stat-card">
			<span class="stat-label">
				{{ 'CLIPS.STATS.AVERAGE_VISIBILITY' | translate }}
				<mat-icon class="stat-info-icon" matTooltipClass="wide-tooltip" matTooltipPosition="above"
					[matTooltip]="'CLIPS.STATS.AVERAGE_VISIBILITY_INFO' | translate">info_outline</mat-icon>
			</span>
			<div class="stat-row">
				<span class="stat-value">{{ (stats.averageVisibilityIndex.today ?? 0) | number:'1.0-0' }}<span class="stat-suffix">/100</span></span>
				@if (visibilityDeltaPercent() !== null && visibilityDeltaPercent() !== 0) {
				<span class="stat-delta" [class.up]="(visibilityDeltaPercent() ?? 0) > 0" [class.down]="(visibilityDeltaPercent() ?? 0) < 0">
					<mat-icon>{{ (visibilityDeltaPercent() ?? 0) > 0 ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					{{ (visibilityDeltaPercent() ?? 0) > 0 ? '+' : '' }}{{ visibilityDeltaPercent() }}% {{ 'CLIPS.STATS.LAST_24_HOURS' | translate }}
				</span>
				}
			</div>
		</div>
		}
		} @else {
		<!-- Card 2: Brand mentions (always 0 for non-brand) -->
		<div class="stat-card">
			<span class="stat-label">
				{{ 'CLIPS.STATS.BRAND_MENTIONS' | translate }}
				<mat-icon class="stat-info-icon" matTooltipClass="wide-tooltip" matTooltipPosition="above"
					[matTooltip]="'CLIPS.STATS.BRAND_MENTIONS_INFO' | translate">info_outline</mat-icon>
			</span>
			<div class="stat-row">
				<span class="stat-value">0</span>
			</div>
		</div>

		<!-- Card 3: Most active medium -->
		<div class="stat-card">
			<span class="stat-label">
				{{ 'CLIPS.STATS.MOST_ACTIVE_MEDIUM' | translate }}
				<mat-icon class="stat-info-icon" matTooltipClass="wide-tooltip" matTooltipPosition="above"
					[matTooltip]="'CLIPS.STATS.MOST_ACTIVE_MEDIUM_INFO' | translate">info_outline</mat-icon>
			</span>
			<div class="stat-row">
				<span class="stat-value-name">{{ mostActiveMediumName || '/' }}</span>
				@if (stats.mostActiveMedium?.count) {
				<span class="stat-count-pill">{{ stats.mostActiveMedium?.count ?? 0 }} {{ 'CLIPS.STATS.CLIPS' | translate }}</span>
				}
			</div>
		</div>

		<!-- Card 4: Most present category -->
		<div class="stat-card">
			<span class="stat-label">
				{{ 'CLIPS.STATS.MOST_PRESENT_CATEGORY' | translate }}
				<mat-icon class="stat-info-icon" matTooltipClass="wide-tooltip" matTooltipPosition="above"
					[matTooltip]="'CLIPS.STATS.MOST_PRESENT_CATEGORY_INFO' | translate">info_outline</mat-icon>
			</span>
			<div class="stat-row">
				<span class="stat-value-name">{{ mostPresentCategoryName || '/' }}</span>
				@if (stats.mostPresentCategory?.count) {
				<span class="stat-count-pill">{{ stats.mostPresentCategory?.count ?? 0 }} {{ 'CLIPS.STATS.CLIPS' | translate }}</span>
				}
			</div>
		</div>
		}

	</div>

	<!-- Most valuable clip: full-width long card below the stats row -->
	@if (hasCompanyTags && mostValuableClip) {
	<div class="most-valuable-card" (click)="emitOpenClip()">
		<div class="most-valuable-header">
			<mat-icon class="flame-icon">local_fire_department</mat-icon>
			<span class="stat-label">{{ 'CLIPS.STATS.MOST_VALUABLE_CLIP' | translate }}</span>
		</div>
		<span class="most-valuable-title">{{ mostValuableClipTitle() }}</span>
		<div class="most-valuable-meta">
			@if (mostValuableClip.visibilityIndex != null) {
			<span class="meta-pill reach">{{ 'CLIPS.STATS.REACH' | translate }}: {{ mostValuableClip.visibilityIndex }}/100</span>
			}
			@if (mostValuableClip.sentiment?.sentimentScore != null) {
			<span class="meta-pill influence" [class.positive]="(mostValuableClip.sentiment?.sentimentScore ?? 0) > 0" [class.neutral]="mostValuableClip.sentiment?.sentimentScore === 0" [class.negative]="(mostValuableClip.sentiment?.sentimentScore ?? 0) < 0">
				{{ 'CLIPS.STATS.INFLUENCE' | translate }}: {{ (mostValuableClip.sentiment?.sentimentScore ?? 0) > 0 ? '+' : '' }}{{ mostValuableClip.sentiment?.sentimentScore }}
			</span>
			}
		</div>
	</div>
	}
</div>
}
